import React from 'react';
import { isWidgetMode } from '../../utils/widgetDetection';
import Footer from '../../shared/components/Footer';

interface CenteredLayoutProps {
  children: React.ReactNode;
  backgroundColor?: string | null;
}

const CenteredLayout: React.FC<CenteredLayoutProps> = ({ children, backgroundColor }) => {
  const isWidget = isWidgetMode();
  const defaultBackgroundColor = 'rgba(0, 0, 0, 0.95)';
  const bgColor = backgroundColor || defaultBackgroundColor;

  return (
    <div
      className="lp-min-h-screen lp-flex lp-flex-col"
      style={{ backgroundColor: bgColor }}
    >
      <main
        className="lp-flex-1 lp-min-h-[calc(100vh-64px)] lp-bg-gradient-to-r lp-from-transparent lp-via-[#DDB889]/5 lp-to-transparent"
        style={isWidget ? { backgroundColor: bgColor } : {}}
      >
        <div className="lp-h-full lp-py-4 sm:lp-py-8 md:lp-py-12 lp-flex lp-justify-center">
          <div className="lp-relative lp-w-[90%] sm:lp-w-[85%] md:lp-w-[80%] lg:lp-w-[70%]">
            <div className="lp-min-h-[600px] sm:lp-min-h-[700px] md:lp-min-h-[800px] lp-bg-opacity-50 lp-shadow-lg lp-rounded-lg lp-overflow-hidden lp-text-[#DDB889] lp-font-boska">
              {children}
            </div>
          </div>
        </div>
      </main>
      <Footer includeTop={false} />
    </div>
  );
};

export default CenteredLayout;
